import { type FC } from 'react';
import AppCard from './AppCard';
import { UiIconTranslate } from '@/lib/ui';

export interface LiveTranslationProps {
  navLink?: string
  isSelected?: boolean
  isEnabled?: boolean
}

const LiveTranslationCard: FC<LiveTranslationProps> = ({
  navLink = undefined,
  isSelected = false,
  isEnabled = false,
}) => {
  return (
    <AppCard
      navLink={navLink}
      icon={(<UiIconTranslate size={'3xl'} color={isEnabled ? 'green.500' : 'gray.800'} />)}
      name={'Live translation'}
      isSelected={isSelected}
    />
  );
};
export default LiveTranslationCard;
